import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const AdminContacts = React.lazy(
    () => import(/* webpackChunkName: "admin-contacts" */ '../../../../containers/Admin/Contacts')
);
const AdminContactsTable = React.lazy(
    () =>
        import(
            /* webpackChunkName: "admin-contacts-table" */ '../../../../containers/Admin/Contacts/children/ContactsTable'
        )
);
const AdminContactInfo = React.lazy(
    () =>
        import(
            /* webpackChunkName: "admin-contact-info" */ '../../../../containers/Admin/Contacts/children/ContactInfo'
        )
);

export const AdminContactsRoutes: RouteObject = {
    path: 'contacts',
    element: (
        <React.Suspense fallback={<>...</>}>
            <AdminContacts />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <AdminContactsTable />
                </React.Suspense>
            )
        },
        {
            path: 'contact/:contactId',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <AdminContactInfo />
                </React.Suspense>
            )
        }
    ]
};
